import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Box, Button, Dialog, Typography } from '@material-ui/core'

import useStyles from './styles'

import constants from 'constants/index'

const {
  TEXT_FIELD_PLACEHOLDERS,
  TEXT_FIELD_BLOCKING_PLACEHOLDERS,
  TEXT_FIELDS,
} = constants.cookies.ageGateTextOverride

const BLOCK_SVG = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ width: 160, height: 160 }}
  >
    <circle cx="12" cy="12" r="10" />
    <line x1="4.93" y1="4.93" x2="19.07" y2="19.07" />
  </svg>
)

const AgeGatePreviewModal = ({
  open,
  onClose,
  overlayOpacity,
  selectedLanguage,
  getAgeGateTextOverride,
  primaryColor,
  secondaryColor,
  fontFamily,
}) => {
  const classes = useStyles({ primaryColor, secondaryColor, fontFamily })
  const [blocked, setBlocked] = useState(false)

  const handleClose = () => {
    setBlocked(false)
    onClose()
  }

  const getTextValue = (fieldKey, placeholders) =>
    getAgeGateTextOverride(fieldKey) ||
    placeholders?.[selectedLanguage]?.[fieldKey] ||
    ''

  const title = getTextValue(TEXT_FIELDS.TITLE, TEXT_FIELD_PLACEHOLDERS)
  const description = getTextValue(
    TEXT_FIELDS.DESCRIPTION,
    TEXT_FIELD_PLACEHOLDERS,
  )
  const acceptButton = getTextValue(
    TEXT_FIELDS.ACCEPT_BUTTON,
    TEXT_FIELD_PLACEHOLDERS,
  )
  const rejectButton = getTextValue(
    TEXT_FIELDS.REJECT_BUTTON,
    TEXT_FIELD_PLACEHOLDERS,
  )
  const blockTitle = getTextValue(
    TEXT_FIELDS.BLOCK_TITLE,
    TEXT_FIELD_BLOCKING_PLACEHOLDERS,
  )
  const blockDescription = getTextValue(
    TEXT_FIELDS.BLOCK_DESCRIPTION,
    TEXT_FIELD_BLOCKING_PLACEHOLDERS,
  )

  const backdropOpacity = (overlayOpacity ?? 50) / 100

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      className={classes.dialog}
      fullWidth
      BackdropProps={{
        style: { backgroundColor: `rgba(0, 0, 0, ${backdropOpacity})` },
      }}
    >
      {blocked ? (
        <Box className={classes.blockWrap}>
          <Box className={classes.blockBg}>{BLOCK_SVG}</Box>
          <Box className={classes.blockContent}>
            <Typography component="h2" className={classes.blockTitle}>
              {blockTitle}
            </Typography>
            <Typography component="p" className={classes.blockMsg}>
              {blockDescription}
            </Typography>
          </Box>
        </Box>
      ) : (
        <Box className={classes.modal}>
          <Typography component="h2" className={classes.title}>
            {title}
          </Typography>
          <Typography component="p" className={classes.description}>
            {description}
          </Typography>
          <Box className={classes.actions}>
            <Button
              variant="contained"
              disableElevation
              className={classes.btnYes}
              onClick={handleClose}
            >
              {acceptButton}
            </Button>
            <Button
              variant="outlined"
              className={classes.btnNo}
              onClick={() => setBlocked(true)}
            >
              {rejectButton}
            </Button>
          </Box>
        </Box>
      )}
    </Dialog>
  )
}

AgeGatePreviewModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  overlayOpacity: PropTypes.number,
  selectedLanguage: PropTypes.string,
  getAgeGateTextOverride: PropTypes.func.isRequired,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  fontFamily: PropTypes.string,
}

export default AgeGatePreviewModal
